/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CompuweighResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Compuweigh<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetCompuweigh
   * @request GET:/compuweigh
   * @secure
   */
  getCompuweigh = (params: RequestParams = {}) =>
    this.request<CompuweighResponse, any>({
      path: `/compuweigh`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCompuweigh
   * @request OPTIONS:/compuweigh
   */
  optionsCompuweigh = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCompuweigh2
   * @request OPTIONS:/compuweigh/{id}
   * @originalName optionsCompuweigh
   * @duplicate
   */
  optionsCompuweigh2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
